/* Ocean Silver · carrito lateral: agregar sin recargar + complementos */
(function () {
  if (window.__oceanCart) return;
  window.__oceanCart = true;
  function drawer() { return document.querySelector('cart-drawer'); }
  function addUrl() { return (window.routes && window.routes.cart_add_url) || '/cart/add'; }
  function render(d, j) { d.classList.remove('is-empty'); d.renderContents(j); }
  function add(fd) {
    fd.append('sections', 'cart-drawer,cart-icon-bubble');
    fd.append('sections_url', window.location.pathname);
    return fetch(addUrl(), { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: fd })
      .then(function (r) { return r.json(); })
      .then(function (j) { if (j.status) { throw new Error(j.description || j.message || 'No se pudo agregar'); } return j; });
  }
  function showError(anchor, msg) {
    var box = anchor.parentElement.querySelector('[data-os-cart-error]');
    if (!box) { box = document.createElement('p'); box.className = 'os-error'; box.setAttribute('role', 'alert'); box.setAttribute('data-os-cart-error', ''); anchor.insertAdjacentElement('afterend', box); }
    box.textContent = msg;
  }
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form.os-product-form')) return;
    if (e.submitter && e.submitter.name === 'return_to') return;
    var d = drawer();
    if (!d || typeof d.renderContents !== 'function') return;
    e.preventDefault();
    var btn = form.querySelector('[data-os-add]');
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    var old = form.querySelector('[data-os-cart-error]'); if (old) old.remove();
    add(new FormData(form))
      .then(function (j) { render(d, j); })
      .catch(function (err) { if (btn) showError(btn, err.message); })
      .finally(function () { if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); } });
  });
  document.addEventListener('click', function (e) {
    var up = e.target.closest('[data-os-upsell]');
    if (up) {
      e.preventDefault();
      var d = drawer(); var fd = new FormData();
      fd.append('id', up.dataset.osUpsell); fd.append('quantity', '1');
      up.disabled = true; up.textContent = 'Agregando…';
      add(fd).then(function (j) { render(d, j); }).catch(function (err) { up.disabled = false; up.textContent = 'Agregar al carrito'; showError(up, err.message); });
      return;
    }
    var nav = e.target.closest('[data-osc-nav]');
    if (nav) {
      var track = nav.parentElement.querySelector('[data-osc-track]');
      if (track) track.scrollBy({ left: track.clientWidth * parseInt(nav.dataset.oscNav, 10), behavior: 'smooth' });
    }
  });
})();